// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-794ebfd1] .ql-editor img{width:5.208333rem}", ""]);
// Exports
module.exports = exports;
